import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import YardPacman from './YardPacman'

export const YardPacmanPage: FC = () => {
  const navigate = useNavigate()
  return <YardPacman onClose={() => navigate(PATHS.arcade.url)} />
}
